import React, { useState } from 'react';
import useCustomer from 'hooks/useCustomer';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { PlusOutlined, ZoomInOutlined } from '@ant-design/icons';
import Page from 'components/Page';
import Loading from 'components/Loading';
import { EDIT_FUNNEL } from 'shared/constants/permissions';

import Table from 'components/Table';
import { useHistory } from 'react-router-dom';
import globalMessages from 'translations/messages';
import CreateFunnelDrawer from './CreateFunnelDrawer';
import messages from './messages';

const QUERY = gql`
  query($customerId: ID!) {
    funnels(customerId: $customerId) {
      id
      title
      website { id title }
      steps {
        id
      }
    }
  }
`;

const columns = [{
  title: <FormattedMessage {...messages.funnel} />,
  dataIndex: 'title',
}, {
  title: <FormattedMessage {...globalMessages.website} />,
  dataIndex: ['website', 'title'],
}, {
  title: <FormattedMessage {...messages.steps} />,
  dataIndex: 'steps',
  render: (steps) => steps.length,
}];

const Funnels = () => {
  const history = useHistory();
  const { customer, loading: customerLoading, hasCustomerPermission } = useCustomer();

  const { data, loading } = useQuery(QUERY, { variables: { customerId: customer?.id }, skip: !customer });
  const [createFunnel, setCreateFunnel] = useState(false);

  if (loading || customerLoading) {
    return <Loading />;
  }

  const onCreated = (id) => {
    history.push(`/tools/funnels/${id}`);
  };

  const canEdit = hasCustomerPermission(EDIT_FUNNEL);

  const actions = ((record) => (
    <Button onClick={() => history.push(`/tools/funnels/${record.id}`)} icon={<ZoomInOutlined />}>
      View
    </Button>
  ));

  return (
    <Page>
      <Page.Header
        title={<FormattedMessage {...messages.funnels} />}
        extra={canEdit && (
        <Button type="primary" onClick={() => setCreateFunnel(true)}>
          <PlusOutlined />
          <FormattedMessage {...messages.createFunnel} />
        </Button>
        )}
      />

      <Page.Content>
        <Table dataSource={data?.funnels} columns={columns} actions={actions} />
      </Page.Content>

      <CreateFunnelDrawer customerId={customer?.id} open={createFunnel} onClose={() => setCreateFunnel(false)} onDone={onCreated} />
    </Page>
  );
};

export default Funnels;
